import * as angular from "angular";

export class ConsolidatedBillingOrderDialogService {

  constructor(private $mdDialog) {
  }

  payManually(consolidatedBillingOrder, event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/manual-pay-consolidated-billing-order-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {

        $scope.invoiceId;
        $scope.consolidatedBillingOrder = consolidatedBillingOrder;

        $scope.cancel = self.$mdDialog.cancel;

        /////////////////////////////////////////////////////////////////

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.invoiceId);
            }
          }
        }


      }
    })
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .service('consolidatedBillingOrderDialogService', ConsolidatedBillingOrderDialogService);
